import React from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';

import 'moment/locale/es' 

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

import * as serviceWorker from './serviceWorker';
import ApplicationRouter from './router/Router';
import SignalR from './services/SignalR';



moment.locale('es');

ReactDOM.render(<ApplicationRouter />, document.getElementById('root'));

serviceWorker.register({
  onUpdate: registration => {
    const waitingServiceWorker = registration.waiting

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", event => {
        if (event.target.state === "activated") {
          window.location.reload()
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  }
});
// serviceWorker.unregister();
SignalR.start();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
